import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Categories} from "../../models/categories";
import {MatMenuTrigger} from "@angular/material/menu";
import {Router} from "@angular/router";
import {RegistryService} from "../../services/registry.service";


@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit ,OnDestroy{
    cat: Categories[];

    level1_cats = [];
    @Input() fullCat: Categories[];
    subCat: any = [];
    children: any = [];
    childrenCat: any = [];
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    catloadedevent;

    constructor(private router: Router, public registry: RegistryService) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };
    }

    ngOnInit(): void {
        this.cat = [];

        this.catloadedevent = this.registry.CatsLoadedEvent$.subscribe(result => {
            // this.fullCat = result;
            this.fullCat = this.registry.getFullCat();

            this.cat = this.fullCat.filter(v => (v.parent_id === 2 && v.id !=815 && v.id !=814 && v.id != 813));

            var excluded = [815];
            // console.log(this.cat);
            this.cat.forEach( item =>{

            this.level1_cats[item['id']] = this.fullCat.filter(v =>
                (v.parent_id === item['id']) );

            });

            // console.log(this.level1_cats);


        });


        this.fullCat = this.registry.getFullCat();
        if (this.fullCat != null) {
            this.cat = this.fullCat.filter(v => v.parent_id === 2 && v.id !=815 && v.id !=814 && v.id !=813);

            this.cat.forEach( item =>{

                this.level1_cats[item['id']] = this.fullCat.filter(v => (v.parent_id === item['id']));

            });
        }

    }

    getSubCat(id) {
        this.childrenCat = [];
        this.subCat = this.cat.filter(v => v.id === id);
        this.children = this.subCat[0].children.split(',');
        this.children.forEach(e =>
            this.childrenCat = this.childrenCat.concat(this.fullCat.filter(v => v.id === Number(e)))
        );
    }

    goToProductBrowserPage(id) {
        this.router.navigate(['/web/home/product/browser', id]);
    }

    goToCategoriesPage(id) {
        this.removeSearchBarValue(null);
        this.router.navigate(['/web/home/categories', id]);

    }

    removeSearchBarValue(event) {
        if(event != null) {
            event.preventDefault();
        }
        localStorage.setItem('searchKeyword' , '');
    }

    ngOnDestroy(): void {

        if(this.catloadedevent != null)
        {
            this.catloadedevent.unsubscribe();
        }
    }

}
